import {
  WhyUsContainer,
  WhyUsWrapper,
  WInfo,
  WReviews,
  WReviewsContainer,
  FirstReview,
  SecondReview,
  ThirdReview,
} from "./why-us.styles"
import whyUs1 from "../../assets/icons/why-us-1.svg"
import whyUs2 from "../../assets/icons/why-us-2.svg"
import whyUs3 from "../../assets/icons/why-us-3.svg"
import whyUs4 from "../../assets/icons/why-us-4.svg"
import whyUs5 from "../../assets/icons/why-us-5.svg"
import pointer from "../../assets/icons/pointer.svg"
import firstReview from "../../assets/img/firstReview.jpg"
import secondReview from "../../assets/img/secondReview.jpg"
import thirdReview from "../../assets/img/thirdReview.jpg"
import reviewsBg from "../../assets/img/reviews-bg.png"
import Button from "../button/button.component"
// import { Link } from "rou"

import "./styles.scss"

const WhyUs = ({ props }) => {
  const renderButtonText = () => {
    return (
      <div>
        <img src={pointer} alt="" style={{ width: 15, marginRight: 10 }} />
        {props[6]}
      </div>
    )
  }
  return (
    <WhyUsWrapper>
      <WhyUsContainer id="why-us">
        <WInfo>
          <ul>
            <li>
              <h2>{props[1]}</h2>
            </li>
            <li>
              <span className="img">
                <img src={whyUs1} alt="" />
              </span>
              <span className="text">{props[2]}</span>
            </li>
            <li>
              <span className="img">
                <img src={whyUs2} alt="" />
              </span>
              <span className="text">{props[9]}</span>
            </li>
            <li>
              <span className="img">
                <img src={whyUs3} alt="" />
              </span>
              <span className="text">{props[10]}</span>
            </li>
            <li>
              <span className="img">
                <img src={whyUs4} alt="" />
              </span>
              <span className="text">{props[11]}</span>
            </li>
            <li>
              <span className="img">
                <img src={whyUs5} alt="" />
              </span>
              <span className="text">{props[12]}</span>
            </li>
            <li className="maps-to-service">
              <a
                to="https://maps.app.goo.gl/deWR96FZYv6XFcWF7"
                href={"https://maps.app.goo.gl/deWR96FZYv6XFcWF7"}
                target="_blank"
                rel="noreferrer noopener"
                // spy={true}
                // smooth={true}
                // offset={0}
                // duration={500}
                style={{ width: "100%" }}
              >
                <Button children={renderButtonText()} />
              </a>
            </li>
          </ul>
        </WInfo>
        <WReviews>
          <img src={reviewsBg} alt="" className="reviews-bg" />
          <WReviewsContainer>
            <h2>{props[7]}</h2>
            <FirstReview>
              {/* <img className="logo" src={logo} alt="" /> */}
              <img className="firstReview" src={firstReview} alt="" />
            </FirstReview>

            <SecondReview>
              <img src={secondReview} alt="" />
            </SecondReview>

            <ThirdReview>
              <img className="thirdReview" src={thirdReview} alt="" />
              <a
                href={
                  "https://www.google.com/maps/place/Indadent/@47.0159277,28.8493612,18z/data=!4m8!3m7!1s0x40c97d005255f5a7:0xa45d299b00580499!8m2!3d47.0157772!4d28.8501597!9m1!1b1!16s%2Fg%2F11w7hj_v84?entry=ttu&g_ep=EgoyMDI1MDUxNS4xIKXMDSoASAFQAw%3D%3D"
                }
                target="_blank"
                rel="noreferrer"
              >
                <button>
                  {props[8]}
                  {/* <img src={externalLink} alt="" /> */}
                </button>
              </a>
            </ThirdReview>
          </WReviewsContainer>
        </WReviews>
      </WhyUsContainer>
    </WhyUsWrapper>
  )
}

export default WhyUs
